import { render, staticRenderFns } from "./Paginations.vue?vue&type=template&id=3d553ec6"
import script from "./Paginations.vue?vue&type=script&lang=js"
export * from "./Paginations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports